import React from "react";
import {
  FormField,
  FormInput,
  FormSelect,
  Modal,
  ModalFooterButtons,
} from "../../../../components/Modal";

export interface AddPartyDialogProps {
  open: boolean;
  onClose: () => void;
  handleAddParty: () => void;
  addingParty: boolean;
  partyForm: {
    type: "person" | "organization";
    name: string;
    shortName: string;
    email: string;
  };
  setPartyForm: React.Dispatch<
    React.SetStateAction<{
      type: "person" | "organization";
      name: string;
      shortName: string;
      email: string;
    }>
  >;
}

export function AddPartyDialog({
  open,
  onClose,
  handleAddParty,
  addingParty,
  partyForm,
  setPartyForm,
}: AddPartyDialogProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Add Party"
      description="Add a person or organization"
      size="sm"
      footer={
        <ModalFooterButtons
          onCancel={onClose}
          onSubmit={handleAddParty}
          submitLabel={addingParty ? "Saving" : "Save"}
          submitDisabled={!partyForm.name || addingParty}
        />
      }
    >
      <div className="grid grid-cols-2 gap-3">
        <FormField label="Type" required>
          <FormSelect
            options={[
              { value: "person", label: "Person" },
              { value: "organization", label: "Organization" },
            ]}
            value={partyForm.type}
            onChange={(v) =>
              setPartyForm((f) => ({
                ...f,
                type: v as "person" | "organization",
              }))
            }
          />
        </FormField>
        <FormField label="Name" required>
          <FormInput
            placeholder="e.g. Jane Doe or Acme Corp"
            value={partyForm.name}
            onChange={(v) => setPartyForm((f) => ({ ...f, name: v }))}
          />
        </FormField>
      </div>
      <FormField label="Short Name">
        <FormInput
          placeholder="e.g. JD or Acme"
          value={partyForm.shortName}
          onChange={(v) => setPartyForm((f) => ({ ...f, shortName: v }))}
        />
      </FormField>
      <FormField label="Email Address">
        <FormInput
          placeholder="e.g. jane@example.com"
          value={partyForm.email}
          onChange={(v) => setPartyForm((f) => ({ ...f, email: v }))}
        />
      </FormField>
    </Modal>
  );
}
